const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
        }, wait);
    };
}

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

const getYoutubeIdFromUrl = (url) => {
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
    var result = fn();
    if(result) {
      resolve(result);
    }
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments));
      // reject();
    }
  };

  return new Promise(checkCondition);
}

// CUSTOM PARSER ========================
class CustomParser extends HTMLElement {
  connectedCallback() {
    this.style.whiteSpace = 'pre-wrap';
    const textArea = document.createElement('textarea');
    textArea.innerHTML = this.innerHTML;
    const parsedString = textArea.value;
    this.innerHTML = parsedString;
  }
}

customElements.define('dom-parser', CustomParser);
// END CUSTOM PARSER ========================

// Focus trapping for ADA
window.addEventListener('load', () => {
  [...document.querySelectorAll('[role="dialog"]')].forEach(dialog => trapFocusInDialog(dialog));
});

function trapFocusInDialog(dialog) {
  dialog.addEventListener('keydown', function(e) {
    let keyboardfocusableElements = dialog.querySelectorAll('a[href]:not(.hidden a[href]), button:not(.hidden button), input:not(.hidden input), textarea:not(.hidden textarea), select:not(.hidden select), details:not(.hidden details), [tabindex]:not([tabindex="-1"]):not(.hidden [tabindex]:not([tabindex="-1"]))');
    let firstFocusableElement = keyboardfocusableElements[0]; 
    let lastFocusableElement = keyboardfocusableElements[keyboardfocusableElements.length - 1];
    if (e.target.isEqualNode(firstFocusableElement) && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    } else if(e.target.isEqualNode(lastFocusableElement) && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });      
}

const blogFilters = document.querySelectorAll('.js-blog-filter');
const blogSidebar = document.querySelector('.js-blog-sidebar');
const articleFilters = document.querySelectorAll('.js-article-filter');

document.addEventListener('click', e => {
  const element = e.target;
  const isMobile = !window.matchMedia('(min-width: 768px)').matches;
  const marginClass = isMobile ? 'mr-2' : 'ml-2';

  if (element.classList.contains('js-blog-filter')) {
    e.preventDefault();
    fetchFilteredResults(element.href, element.dataset.sectionId);
  }

  if (element.classList.contains('js-open-blog-sidebar')) {
    let blogSidebar = document.querySelector('.js-blog-sidebar');
    blogSidebar.classList.remove('w-0', 'p-0');
    blogSidebar.classList.add('p-6');
    blogSidebar.classList.add(marginClass);
  }

  if (element.classList.contains('js-close-blog-sidebar')) {
    let blogSidebar = document.querySelector('.js-blog-sidebar');
    blogSidebar.classList.add('w-0', 'p-0');
    blogSidebar.classList.remove('p-6');
    blogSidebar.classList.remove(marginClass);
  }

});

async function fetchFilteredResults(path, sectionId) {
  document.body.classList.add('loading');
  const fetchFilteredEvent = new CustomEvent('globals:fetch-filtered-result', {});
  
  await fetch(`${path}?section_id=${sectionId}`)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, "text/html");

      const wrapper =  document.querySelector(`#${sectionId}`);
      if(!wrapper) return;

      const htmlToAppend = (html.querySelector(`#${sectionId}`)?.innerHTML ?? '');
      wrapper.innerHTML = htmlToAppend;
    })
    .then(() => {
      document.body.classList.remove('loading');
      window.dispatchEvent(fetchFilteredEvent);
    })
    .catch((err) => console.error(`Failed to fetch results: ${err}`));
}
if (window.Shopify) {
  if (Shopify.shop === 'ghost-lifestyle.myshopify.com'
  || Shopify.shop === 'ghost-lifestyle-uk.myshopify.com'
  || Shopify.shop === 'ghost-europe.myshopify.com'
  || Shopify.shop === 'ghost-au.myshopify.com') {
    const visitorLocation = sessionStorage.getItem('visitor_location');
    if (visitorLocation) {
      const obj = JSON.parse(visitorLocation);
      if (new Date() > new Date(obj.expiresAt)) {
        fetchLocation()
        .then(result => {
          setLocationCookie(result)
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }
    } else {
      fetchLocation()
      .then(result => {
        setLocationCookie(result)
      })
      .catch(error => {
        console.error('Error:', error);
      });

    }
  }
}

async function fetchLocation() {
  let url = 'https://api.ipgeolocation.io/ipgeo';
  try {
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching location:', error);
  }
}

function renderHelpModal({ id, title, action, copy, actionLabel, target = `_self` }) {
  const existing = document.querySelector(`[data-drawer-content="${id}"]`);
  if (existing) existing.remove();

  document.documentElement.insertAdjacentHTML("beforeend", `
    <template data-direction="center" data-drawer-content="${id}">
      <div class="custom-modal-inner !overflow-visible !py-6 !px-4 rounded md:!max-w-xl">
        <button 
          class="w-5 h-5 absolute -top-2.5 -right-2.5 p-1 bg-[#444] text-white" 
          data-drawer-action="close"
          data-drawer-id="${id}"
        >
          <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 12 12">
            <path d="M10.795 0 6 4.795 1.2 0 0 1.2 4.795 6 0 10.795 1.2 12 6 7.205 10.795 12 12 10.795 7.205 6 12 1.2z"></path>
          </svg>
        </button>
        <div class="flex flex-col text-center">
          <h4 class="text-center capitalize">${title}</h4>
          <strong class="text-center text-[25px] mt-2 font-heading uppercase">${copy}</strong>
          ${(action && actionLabel) ? 
            `
              <a 
                style="--label: '${actionLabel}'"
                href="${action}"
                class="button primary w-full mt-6 before:content-[var(--label)]" 
                data-drawer-id="${id}"
                target="${target}"
              >
                <span>${actionLabel}</span>
              </a>
            ` : 
            `
              <button 
                class="button primary w-full mt-6 before:content-['Close']" 
                data-drawer-action="close"
                data-drawer-id="modal-${id}"
              >
                <span>Close</span>
              </button>
            `
          }
        </div>
      </div>
    </template>
  `);
  
  window.dispatchEvent(new CustomEvent('modal:openById', { 
    detail: id
  }));
}

const showProp65Messages = (() => {
  const visitor_location = JSON.parse(sessionStorage.getItem('visitor_location'));
  const prop_65_containers = document.querySelectorAll('[data-prop-65]');
  
  if (visitor_location && visitor_location.state_prov !== 'California') {
    prop_65_containers.forEach((container) => {
      container.classList.add('hidden');
    });
    return;
  }

  prop_65_containers.forEach((container) => {
    container.classList.remove('hidden');
  })
});

window.addEventListener('load', () => {  
  const visitorLocation = sessionStorage.getItem('visitor_location');
  if (visitorLocation) {
    const obj = JSON.parse(visitorLocation);
    if (new Date() > new Date(obj.expiresAt)) {
      fetchLocation()
        .then(result => {
          setLocationCookie(result)
        })
        .catch(error => {
          console.error('Error:', error);
        });
    } else {
      showProp65Messages();
    }
  } else {
    fetchLocation()
      .then(result => {
        setLocationCookie(result)
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
});

function setLocationCookie(result) {
  const obj = {
    continentCode: result.continent_code,
    countryCode: result.country_code2,
    state_prov: result.state_prov,
    expiresAt: new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 2)).getTime(),
  }
  sessionStorage.setItem('visitor_location', JSON.stringify(obj));

  if (obj.countryCode === `MX`) {
    renderHelpModal({
      id: `redirect-modal`,
      title: `Change Location`,
      action: `https://gnc.com.mx/marcas/ghost.html`,
      copy: `LEGEND! WE'RE AVAILABLE IN-STORE AND ONLINE AT GNC MEXICO–HIT THE BUTTON BELOW TO BE REDIRECTED TO THEIR WEBSITE.`,
      actionLabel: `SHOP GHOST`,
      target: `_blank`,
    });
  } else if (obj.continentCode === 'NA' && window.location.host.startsWith('www.ghost') === false) {
    renderHelpModal({
      id: 'redirect-modal',
      title: 'Change Location',
      action: `https://ghostlifestyle.com${window.location.pathname}`,
      copy: 'LEGEND! Hit the button below to be automatically redirected to our US site.',
      actionLabel: 'Redirect'
    });
  } else if (obj.continentCode === 'EU' && obj.countryCode === 'GB'  && window.location.host.startsWith('uk') === false) {
    renderHelpModal({
      id: 'redirect-modal',
      title: 'Change Location',
      action: `https://uk.ghostlifestyle.com${window.location.pathname}`,
      copy: 'LEGEND! Hit the button below to be automatically redirected to our UK site.',
      actionLabel: 'Redirect'
    });
  } else if (obj.continentCode === 'EU' && obj.countryCode != 'GB' && window.location.host.startsWith('eu') === false) {
    renderHelpModal({
      id: 'redirect-modal',
      title: 'Change Location',
      action: `https://eu.ghostlifestyle.com${window.location.pathname}`,
      copy: 'LEGEND! Hit the button below to be automatically redirected to our EU site.',
      actionLabel: 'Redirect'
    });
  } else if (obj.continentCode === 'OC' && window.location.host.startsWith('au') === false) {
    renderHelpModal({
      id: 'redirect-modal',
      title: 'Change Location',
      action: `https://au.ghostlifestyle.com${window.location.pathname}`,
      copy: 'LEGEND! Hit the button below to be automatically redirected to our AU site.',
      actionLabel: 'Redirect'
    });
  } 

  showProp65Messages(); 
}

function renderReferralModal(message) {
  renderHelpModal({
    id: 'redirect-modal',
    title: 'Referral Code Redemption',
    action: `${window.location.origin}/discount/${message}`,
    copy: `LEGEND! Your 20% off discount code is: "${message}". Enter at checkout, or apply below and view at checkout.`,
    actionLabel: 'Apply your discount'
  });
};

(() => {
  window.addEventListener('load', () => {
    const referralModal = document.querySelector('.referral-modal-container');
    const discountCodeElement = referralModal?.querySelector('.discount-code');
    
    if (discountCodeElement?.innerText) {
      renderReferralModal(discountCodeElement.innerText);
      return;
    }

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          if (discountCodeElement?.innerText) {
            renderReferralModal(discountCodeElement.innerText);
          }
        }
      }
    });

    if (discountCodeElement) {
      observer.observe(discountCodeElement, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  });
})();
